// LeadExpandedIntelligence — Phase 4 of the Leads list-view redesign.
//
// Click any card → expand-in-place. This renders BELOW the card
// content (still within the same row) so the operator can inspect a
// lead without ever leaving the list view. The full drawer stays
// available (Open in drawer button here) for the deeper edit surface.
//
// Reuses existing panels from Lead CC Phases 1-6:
//   - AI Command Center header (score / HWC / commission / probability / NBA)
//   - Digital Twin (personality + readiness + likely objections)
//   - Recommendations (top 3 cross-sells)
//   - Live Assistant chip (opens the drawer's full assistant)
//
// One click brings the entire Lead intelligence surface into the
// list-view flow. Matches the "Notion-style expansion" spec Section 13.

import React from 'react';
import LeadCommandCenterHeader   from './LeadCommandCenterHeader';
import LeadDigitalTwinPanel      from './LeadDigitalTwinPanel';
import LeadRecommendationsPanel  from './LeadRecommendationsPanel';

export default function LeadExpandedIntelligence({ lead, callHistory = [], outreachLog = [], onOpenDrawer, onDraftReply, onCall }) {
  return (
    <div style={{
      background: '#ffffff',
      border: '1px solid #e2e8f0',
      borderRadius: 10,
      padding: 14,
      marginTop: 12,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
        <div style={{
          fontSize: 10, letterSpacing: '0.24em', textTransform: 'uppercase',
          color: '#0891b2', fontWeight: 800,
        }}>Expanded intelligence</div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
          <button
            onClick={(e) => { e.stopPropagation(); onCall?.(lead); }}
            className="text-xs font-bold px-3 py-1.5 rounded-md bg-slate-900 text-white hover:bg-slate-800"
          >📞 Call</button>
          <button
            onClick={(e) => { e.stopPropagation(); onDraftReply?.(lead); }}
            className="text-xs font-bold px-3 py-1.5 rounded-md bg-cyan-600 text-white hover:bg-cyan-700"
          >🤖 Draft reply</button>
          <button
            onClick={(e) => { e.stopPropagation(); onOpenDrawer?.(lead); }}
            className="text-xs font-bold px-3 py-1.5 rounded-md border border-slate-300 text-slate-700 hover:bg-slate-50"
          >Open full drawer →</button>
        </div>
      </div>

      <div style={{ display: 'grid', gap: 12 }}>
        <LeadCommandCenterHeader lead={lead} callHistory={callHistory} outreachLog={outreachLog}/>
        <LeadDigitalTwinPanel lead={lead} callHistory={callHistory} outreachLog={outreachLog}/>
        <LeadRecommendationsPanel lead={lead}/>
      </div>
    </div>
  );
}
